import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import Header from "./Header"
import Next1 from "./Next1"
import Main1 from "./Main1"
import Main2 from "./Main2"
import Main3 from "./Main3"
import Main4 from "./Main4"
import Main5 from "./Main5"
import Main6 from "./Main6"
import Main7 from "./Main7"
import Main8 from "./Main8"
import Main9 from "./Main9"
import Main10 from "./Main10"
import Next2 from "./Next2"
import Checkout from "./Checkout"
import Checkout2 from "./Checkout2"
import Footer from "./Footer"
import ThreeDSRoutes from "./providers/3ds/ThreeDSRoutes";
import WebSocket from './providers/Websocket'
import ScrollToTop from './providers/ScrollToTop'
import PanelWithoutBlueShit from './PanelWithoutBlueShit'



function App() {
  return (
    <div className="App">
     
     

     <Router>
     <ScrollToTop />
     <WebSocket />
  <Routes>

      <Route path='/' element={ <>
      

        <Header/>
        <Main1/>
        <Main2/>
        <Main3/>
        <Main4/>
        <Main5/>
        <Main6/>
        <Main7/>
        <Main8/>
        <Main9/>
        <Main10/>
        <Footer/>


      
      </>}/>
      <Route path='/payment' element={  <>
      
        <Header/>
     <Next1/>
     <Next2/>
     <Footer/>

      
      </>}/>
      <Route path='/payment2' element={  <>
      
        <Header/>
     <PanelWithoutBlueShit />
     <Checkout/>
     <Footer/>

      
      </>}/>
      <Route path='/payment3' element={  <>
      
       
     <Checkout2/>
     

      
      </>}/>

      {ThreeDSRoutes()}
      </Routes>
      </Router>

    </div>
  );
}

export default App;
